import React from 'react';
import styled from 'styled-components';

import Button from 'kingpin/atoms/Button';

import { removeRow } from '../compositeUtils';
import { NO_DRAG_CLASS } from '../constants';

// The toolbar's class, so a press on it doesn't select its row (see
// CompositeCard)
export const ROW_TOOLBAR_CLASS = 'studio-row-toolbar';

// A floating menu's height: a small button, its padding and border
const FLOAT_SIZE = 26;

// Floating on the top right corner of the selected row's outline (inside it
// where there's no room above: the block's first row with its header
// hidden)
const Toolbar = styled.div<{ $isInside: boolean }>`
  position: absolute;
  top: ${(props) => (props.$isInside ? 4 : -FLOAT_SIZE / 2)}px;
  right: 12px;
  z-index: 4;
  display: flex;
  align-items: center;
  padding: 2px;
  border-radius: 8px;
  border: 1px solid var(--color-border-primary);
  background-color: var(--color-bg-primary);
  box-shadow: 0 2px 8px var(--color-studio-drop-target);
  cursor: default;
`;

// The selected row's Delete. Its other settings (dividers, its children,
// moving it out of the group) are in its settings panel, and it's moved by
// its body and resized by its handle (see CompositeCard and RowResizeHandle). Excluded
// from dragging so pressing it doesn't move the block.
const RowToolbar = ({
  rows,
  row,
  isInside,
  onRowsChange,
}: {
  rows: Studio.CompositeRow[];
  row: Studio.CompositeRow;
  // No room above the row (see Toolbar)
  isInside: boolean;
  onRowsChange: (rows: Studio.CompositeRow[]) => void;
}) => (
  <Toolbar
    className={`${NO_DRAG_CLASS} ${ROW_TOOLBAR_CLASS}`}
    $isInside={isInside}
  >
    <span title="Delete row" style={{ display: 'flex' }}>
      <Button
        type="Ghost"
        size="Small"
        icon="cross"
        onClick={() => onRowsChange(removeRow({ rows, rowId: row.id }))}
        testId={`studio-composite-row-remove-${row.id}`}
      />
    </span>
  </Toolbar>
);

export default RowToolbar;
